import { render, staticRenderFns } from "./companieschange.vue?vue&type=template&id=a63f6a7e"
import script from "./companieschange.vue?vue&type=script&lang=js"
export * from "./companieschange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports